import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col } from "antd";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { HeaderSection } from "../../Cards";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import Link from "next/link";

import {
	IconAirFreight,
	IconCharter,
	IconFillAddressSvg,
	IconFillEmailSvg,
	IconFillPhoneSvg,
	IconJetOneSuites,
} from "@/assets/images";

export function ContactUsPrimaryContact({ primary_contact = {} }) {
	return (
		<HomeUtilitiesContainer>
			<Row
				gutter={[
					{ xl: 60, lg: 50, md: 40, sm: 30, xs: 0 },
					{ xl: 30, lg: 30, md: 24, sm: 20, xs: 12 },
				]}
				align="middle"
			>
				<EachCol
					xl={{ span: 12, order: 1 }}
					lg={{ span: 12, order: 1 }}
					md={{ span: 24, order: 1 }}
					sm={{ span: 24, order: 2 }}
					xs={{ span: 24, order: 2 }}
				>
					<ImageContainer>
						<EachImage>
							<RAImage
								url={PATH_PUBLIC_IMAGES.contact_image_1}
								width="100%"
								height="100%"
								borderRadius="12px"
								objectFit="contain"
							/>
						</EachImage>
					</ImageContainer>
				</EachCol>
				<EachCol
					xl={{ span: 12, order: 2 }}
					lg={{ span: 12, order: 2 }}
					md={{ span: 24, order: 2 }}
					sm={{ span: 24, order: 1 }}
					xs={{ span: 24, order: 1 }}
				>
					<WrapperContent>
						<HeaderSection
							title={primary_contact?.title || ""}
							description={primary_contact?.sub_title || ""}
						/>
					</WrapperContent>
					<WrapperCardSection>
						<CardPrimaryContact
							icon={
								<RAImage url={primary_contact?.contact1?.icon ?? IconCharter} width={24} height={24} />
							}
							title={primary_contact?.contact1?.title || ""}
							phone={formatPhoneNumberIntl(primary_contact?.contact1?.phone || "")}
							email={primary_contact?.contact1?.email || ""}
							address={primary_contact?.contact1?.address || ""}
							google_map_link={primary_contact?.contact1?.google_map_link}
						/>
						<CardPrimaryContact
							icon={
								<RAImage
									url={primary_contact?.contact2?.icon ?? IconJetOneSuites}
									width={24}
									height={24}
								/>
							}
							title={primary_contact?.contact2?.title || ""}
							phone={formatPhoneNumberIntl(primary_contact?.contact2?.phone || "")}
							email={primary_contact?.contact2?.email || ""}
							address={primary_contact?.contact2?.address || ""}
							google_map_link={primary_contact?.contact2?.google_map_link}
						/>
						<CardPrimaryContact
							icon={
								<RAImage
									url={primary_contact?.contact3?.icon ?? IconAirFreight}
									width={24}
									height={24}
								/>
							}
							title={primary_contact?.contact3?.title || ""}
							phone={formatPhoneNumberIntl(primary_contact?.contact3?.phone || "")}
							email={primary_contact?.contact3?.email || ""}
							address={primary_contact?.contact3?.address || ""}
							google_map_link={primary_contact?.contact3?.google_map_link}
						/>
					</WrapperCardSection>
				</EachCol>
			</Row>
		</HomeUtilitiesContainer>
	);
}

const CardPrimaryContact = ({ icon, title = "", email = "", phone = "", address = "", google_map_link = "" }) => {
	return (
		<WrapperCardPrimary>
			<div>{icon}</div>
			<WrapperCardItem>
				<RATypography variant="sub-heading3" color="#222">
					{title || "_"}
				</RATypography>
				<WrapperRow>
					<RAImage url={IconFillPhoneSvg} width={20} height={20} />
					<a href={`tel:${phone}`}>
						<RATypography variant="body3" color="#222">
							{phone || "_"}
						</RATypography>
					</a>
				</WrapperRow>
				<WrapperRow>
					<RAImage url={IconFillEmailSvg} width={20} height={20} />
					<a href={`mailto:${email}`}>
						<RATypography variant="body3" color="#222">
							{email || "_"}
						</RATypography>
					</a>
				</WrapperRow>
				<WrapperRow>
					<RAImage url={IconFillAddressSvg} width={20} height={20} />
					<Link href={google_map_link || ""} target="_blank" prefetch>
						<RATypography variant="body3" color="#222">
							{address || "_"}
						</RATypography>
					</Link>
				</WrapperRow>
			</WrapperCardItem>
		</WrapperCardPrimary>
	);
};

const WrapperCardPrimary = styled.div`
	display: flex;
	gap: 16px;
	border-radius: 8px;
	background: #fafafa;
	padding: 16px 20px;
`;
const WrapperCardItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
const WrapperCardSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;
const ImageContainer = styled.div`
	display: grid;
	padding-top: 40px;
	grid-template-columns: 1fr;
	grid-template-rows: 420px 280px;
	@media (max-width: 1199px) {
		grid-template-rows: 420px 240px;
	}
	@media (max-width: 991px) {
		grid-template-rows: 320px 160px;
	}
	@media (max-width: 767px) {
		grid-template-rows: 228px 152px;
	}
	@media (max-width: 575px) {
		grid-template-rows: 202px 136px;
	}
`;
const EachImage = styled.div`
	&:first-child {
		grid-column: 1/8;
		grid-row: 1/3;
	}
	&:nth-child(2) {
		grid-column: 4/6;
		grid-row: 1/2;
	}
	&:nth-child(3) {
		grid-column: 4/6;
		grid-row: 2/3;
	}
`;
const HomeUtilitiesContainer = styled.div`
	width: 100%;
	max-width: 1442px;
`;
const EachCol = styled(Col)``;
const WrapperContent = styled.div`
	margin: 40px 0px 20px;
`;
const WrapperRow = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 12px;
`;
